// extracted by mini-css-extract-plugin
export var headingLink = "HeadingLink-module--headingLink--23c2c";